import React from 'react';

import Markdown from 'markdown-to-jsx';
import classnames from 'classnames';
import style from '../cssmodules/pageArticle.module.scss';
import PageArticleIcon from './PageArticleIcon';

function PageArticle({ title, intro, quote, body, icon }) {
  return (
    <div className={style.article}>
      <h1 className={classnames(style.title, 'heading1')}>{title}</h1>
      <div className={style.wrapper}>
        <div className={style.content}>
          <Markdown
            className={classnames(style.lead, 'stack')}
            options={{ forceBlock: true }}
          >
            {intro}
          </Markdown>
          <Markdown className={classnames(style.body, 'bodyText', 'stack')}>
            {body}
          </Markdown>
        </div>
        <div className={style.aside}>
          <div className="blockquote">
            <PageArticleIcon icon={icon} />
            <blockquote>
              <p>{quote}</p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageArticle;
